module.exports = __webpack_public_path__ + "static/media/upload-plus.239947a5.png";